// extracted by mini-css-extract-plugin
export default {"loadingContainer":"TimeSlotLoadingSkeleton-module__loadingContainer___1wJvH","loadingItem":"TimeSlotLoadingSkeleton-module__loadingItem___20492"};